const filterDefault = {
  attendance: 'presencial',
  paymentForm: 'particular',
  specialty: null,
  medicalInsurance: null,
  location: null,
  tenant: null,
  professional: null,
  date: null,
}

export default {
  filter: filterDefault,
  professionals: [],
  specialties: [],
  medicalInsurances: [],
  company: null,
  companies: null,
  attendances: [
    //
  ],
  fullDaysOrNotAvaible: [
    //
  ],
  bookingStep: 0,
  selected: {
    medicalInsurance: null,
    date: null,
    choosedTime: null,
    tenant: null,
    professional: null,
    attendance: null,
    schedules: [],
  }
}
